import { SupplementaryEquipmentTakeBackComponent } from '@sdbn/appclient';
import { SupplementaryEquipmentHandoutComponent } from '@sdbn/appclient';
import { DialogLayout } from 'src/app/shared/dialog-layout/dialog-layout';
import { RegisterEntranceDialogData, RegisterEntranceComponent } from './../dialog/register-entrance/component/register-entrance.component';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { RegisterEntranceCombinedDialogData, RegisterEntranceCombinedComponent } from './../component/register-entrance-combined/register-entrance-combined.component';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from '@sdbn/appclient';

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  private selectTransportSubject = new Subject<number>();
  public selectTransport$ = this.selectTransportSubject.asObservable();

  private clientParameters = TMCClientParameters;

  constructor(
    private http: HttpService,
    private dialog: MatDialog,
    private configurationService: ConfigurationService) { }


  /** Notifies all interested components about the selection request for this transport. */
  public selectTransport(transportId: number) {
    this.selectTransportSubject.next(transportId);
  }

  emergencyCall(language: string) {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'emergency');

    // keep focus in current window
    window.focus();

    const url = `${environment.transportOverviewEndpoint}/ermergency-call`;
    this.http.postWithArraybufferResponse<any>(url, language).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  public openHandoutSupplementaryEquipmentDialog(transportId: number, callback: (result: any) => void) {

    const dialogRef = this.dialog.open(SupplementaryEquipmentHandoutComponent, {
      maxHeight: '95vh',
      data: { transportId: transportId },
      panelClass: DialogLayout.panelClass
    });

    dialogRef.afterClosed().subscribe(result => {
      callback(result);
    });
  }

  public openTakeBackSupplementaryEquipmentDialog(transportId: number, callback: () => any) {
    const dialogRef = this.dialog.open(SupplementaryEquipmentTakeBackComponent, {
      maxHeight: '95vh',
      data: { transportId: transportId },
      panelClass: DialogLayout.panelClass
    });

    dialogRef.afterClosed().subscribe(result => {
      callback();
    });
  }

  public openRegisterEntranceDialog(transportId: number, callback: (result: any) => any) {
    this.performRegisterEntrance(transportId, callback);
  }

  private performRegisterEntrance(transportIdentifier: number, callback: (result: any) => any) {
    let dialogRef = null;
    if (this.configurationService.isEnabled(this.clientParameters.FEATURES_COMBINED_ENTRANCE, false)) {
      const dialogData: RegisterEntranceCombinedDialogData = {
        transportId: transportIdentifier,
        callback: () => { }
      };

      dialogRef = this.dialog.open(RegisterEntranceCombinedComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: DialogLayout.panelClass
      });

    } else {
      const dialogData: RegisterEntranceDialogData = {
        transportId: transportIdentifier,
        callback: () => { }
      };

      dialogRef = this.dialog.open(RegisterEntranceComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: DialogLayout.panelClass
      });
    }
    dialogRef.afterClosed().subscribe(result => {
      callback(result);
    });
  }

  public createHandout(transportId: number, documentIdentifier: string) {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'emergency');

    // keep focus in current window
    window.focus();

    const url = `${environment.transportOverviewEndpoint}/print-handout`;
    this.http.postWithArraybufferResponse<any>(url, { transportId: transportId, documentIdentifier: documentIdentifier }).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }
}
